export const ADD_CART = "ADD_CART";
export const HANDLE_CART = "HANDLE_CART";
export const GET_CART = "GET_CART";
export const REMOVE_CART = "REMOVE_CART";
export const DELETE_CART = "DELETE_CART";